import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { Cycle } from 'modules/attendance/lib/attendanceDateNavigatorContext'
import type { TimeTrackingViewType } from 'modules/attendance/lib/useCustomPeriodPath'

export type DetailParams = {
  periodType: Cycle
  year: number
  month: number
  day: number
}

const isCycle = (periodType?: string): periodType is Cycle => {
  switch (periodType) {
    case Cycle.daily:
    case Cycle.weekly:
    case Cycle.fortnightly:
    case Cycle.monthly:
      return true
    default:
      return false
  }
}

type RouteParams = {
  periodType?: string
  year?: string
  month?: string
  day?: string
}

export const buildTimeTrackingDetailParams = (dateFrom: Date, cycle: Cycle): DetailParams => {
  return {
    periodType: cycle,
    year: dateFrom.getFullYear(),
    month: dateFrom.getMonth() + 1,
    day: dateFrom.getDate(),
  }
}

export const buildTimeTrackingDetailParamsFromParams = (
  params: RouteParams,
  dateFrom: Date,
  cycle: Cycle
): DetailParams => {
  const year = Number(params.year)
  const month = Number(params.month)
  const day = Number(params.day)
  if (
    isCycle(params.periodType) &&
    Number.isFinite(year) &&
    Number.isFinite(month) &&
    Number.isFinite(day)
  ) {
    return {
      periodType: params.periodType,
      year,
      month,
      day,
    }
  }

  return buildTimeTrackingDetailParams(dateFrom, cycle)
}

export const usePersistedTimeTrackingViewType = () => {
  const [, setViewType] = useLocalStorage<TimeTrackingViewType>(
    LOCAL_STORAGE_KEYS.timeTrackingViewType
  )

  return (detailParams: DetailParams) => {
    setViewType(detailParams)
  }
}
